export default [
  {
    title: "국소배기장치 검사 시 주의사항",
    tableHeaderTitle: "검사 시 주의 사항",
    list: [
      {
        content: "가. 주변의 작업자에게 검사중임을 알리는 경고 표지를 준비하여 현장에 부착\n예) “출입금지”, “작동(운전, 조작) 금지”, “검사 중” 등",
        isChecked: "",
      },
      {
        content: "나. 국소배기장치의 제어풍속이 적정기준 이하일 경우 검사 시 유해물질의 가스·증기 또는 분진을 흡입할 수 있으므로 필요 보호구를 반드시 착용하여야 한다.",
        isChecked: "",
      },
      {
        content: "다. 높은 곳에 설치 된 덕트, 배풍기, 공기정화장치, 최종배기구 등 검사 시 추락의 위험이 있으므로 추락방지조치 여부 확인 및 보호구를 착용하여야 한다.",
        isChecked: "",
      },
      {
        content: "라. 회전중인 전동기 회전축, 벨트, 배풍기 등에 신체의 일부가 끼이거나 말리지 않도록 주의하여야 한다.",
        isChecked: "",
      },
      {
        content: "마. 안전장치는 고장일 수 있으므로 이를 항상 유념하여야 한다.",
        isChecked: "",
      },
    ],
  },
  {
    title: "스펙 확인",
    tableHeaderTitle: "확인사항",
    list: [
      {
        title: "1. 실물 및 명판 확인",
        content: "종류(포위,외부,레시버) 확인",
        isChecked: "",
      },
      {
        title: "1. 실물 및 명판 확인",
        content: "제조자, 제조년월일, 후드 배기유량 확인",
        isChecked: "",
      },
      {
        title: "2. 작업환경측정결과 확인",
        content: "최근 2년치 측정값 확인, 취급물질 확인",
        isChecked: "",
      },
    ],
  },
  {
    title: "후드",
    tableHeaderTitle: "확인사항",
    list: [
      {
        title: "1. 후드의 설치상태 및 표면상태",
        content: "유해물질 발산원마다 후드 설치 여부 확인",
        isChecked: "",
      },
      {
        title: "1. 후드의 설치상태 및 표면상태",
        content: "후드 형태가 유해물질을 흡입하기에 적절한 형식과 크기인지 확인\n» 근로자의 호흡위치가 오염원과 후드 사이에 위치하지 않으며, 후드가 유해물질 발생원 가까이 위치해야 함",
        isChecked: "",
      },
      {
        title: "1. 후드의 설치상태 및 표면상태",
        content: "후드 내·외면의 마모, 부식, 흠집, 기타 손상 유무 확인",
        isChecked: "",
      },
      {
        title: "2. 후드의 흡입기류 및 흡입성능",
        content: "흡입기류를 방해하는 기둥, 벽 등의 구조물의 유무 확인",
        isChecked: "",
      },
      {
        title: "2. 후드의 흡입기류 및 흡입성능",
        content: "후드 내부, 전처리필터 등의 퇴적물로 인한 제어풍속 저하 여부 확인",
        isChecked: "",
      },
      {
        title: "2. 후드의 흡입기류 및 흡입성능",
        content: "스모크테스터(발연관)를 이용하여 흡입기류(스모크)가 완전히 후드 내부로 흡입되는지 확인",
        isChecked: "",
      },
      {
        title: "2. 후드의 흡입기류 및 흡입성능",
        content: "후드의 제어풍속 측정\n" +
          "»「산업안전보건기준에관한규칙」제429조 및 제609조, 별표13과 별표17의 제어풍속에 적합한지확인[참고1]",
        isChecked: "",
      },
    ],
  },
  {
    title: "덕트",
    tableHeaderTitle: "확인사항",
    list: [
      {
        title: "1. 표면 및 내면상태 등",
        content: "덕트 내외면의 파손, 변형 등으로 압력손실 증가 또는 공기 유입 및 누출, 이상음, 이상진동 유무 확인\n",
        isChecked: "",
      },
      {
        title: "1. 표면 및 내면상태 등",
        content: "덕트 내면의 분진, 오일미스트 등 퇴적물로 인한 이상 발생 유무 확인\n",
        isChecked: "",
      },
      {
        title: "1. 표면 및 내면상태 등",
        content: "플렉시블(flexible) 덕트의 심한 굴곡, 꼬임 등으로 인한 압력손실 유무 확인\n",
        isChecked: "",
      },
      {
        title: "1. 표면 및 내면상태 등",
        content: "접속부의 공기 유입이나 누출에 의한 이상음 발생 여부 확인\n",
        isChecked: "",
      },
      {
        title: "1. 표면 및 내면상태 등",
        content: "플랜지의 결합볼트, 너트, 패킹의 손상 유무 확인",
        isChecked: "",
      },
      {
        title: "2. 댐퍼",
        content: "댐퍼의 손상 여부와 정상작동 상태 확인",
        isChecked: "",
      },
      {
        title: "2. 댐퍼",
        content: "적정 제어풍속 또는 필요 풍량에 적절하게 개폐되며 방향이 올바르게 표시되어 있는지 확인",
        isChecked: "",
      },
    ],
  },
  {
    title: "전기설비",
    tableHeaderTitle: "확인사항",
    list: [
      {
        title: "1. 배전반 등",
        content: "배전반, 제어반의 명칭, 전원의 정격 표시된 이름판 확인",
        isChecked: "",
      },
      {
        title: "1. 배전반 등",
        content: "외함의 구조 및 폐쇄형 잠금장치 사용 여부 확인",
        isChecked: "",
      },
      {
        title: "1. 배전반 등",
        content: "운전 상태를 표시하는 표시등 및 버튼별 명칭 표기 여부 확인",
        isChecked: "",
      },
      {
        title: "1. 배전반 등",
        content: "조작용 전기회로, 방호장치 조작용 전기회로 전압은 교류 대지전압 150V 이하 또는 직류 300V 이하인지 확인",
        isChecked: "",
      },
      {
        title: "1. 배전반 등",
        content: "퓨즈의 정격전류 또는 그 밖에 과전류 보호장치의 전류설정치 적정성 확인\n» 예상 과전류를 고려하여 가능한 낮게 선정",
        isChecked: "",
      },
      {
        title: "1. 배전반 등",
        content: "과전류 보호장치의 정격전류 또는 설정의 적정성 확인",
        isChecked: "",
      },
      {
        title: "1. 배전반 등",
        content: "계전기의 절손, 변형, 부식, 열화 발생 여부 확인",
        isChecked: "",
      },
      {
        title: "2. 배선",
        content: "배선 피복의 손상, 파손, 탄화 유무 확인",
        isChecked: "",
      },
      {
        title: "2. 배선",
        content: "단자체결부의 전용 단자 사용 여부 및 볼트, 너트 풀림 또는 탈락 여부 확인",
        isChecked: "",
      },
      {
        title: "3. 접지 확인 및 접지값 측정",
        content: "전동기 외함 배전반 제어반의 프레임 등의 접지 적절성 확인 및 접지저항 측정\n» 400V 미만일 때 100Ω 이하, 400V 이상일 때 10Ω 이하일 것\n» 방폭은 전압에 관계없이 10Ω 이하일 것",
        isChecked: "",
      },
    ],
  },
  {
    title: "공기정화장치",
    tableHeaderTitle: "확인사항",
    list: [
      {
        title: "1. 공기정화장치",
        content: "오염물질의 종류, 특성에 적합한 형식 및 구조인지 확인",
        isChecked: "",
      },
      {
        title: "1. 공기정화장치",
        content: "외면 또는 내면의 파손, 변형, 부식 등 유무 확인",
        isChecked: "",
      },
      {
        title: "1. 공기정화장치",
        content: "구동장치, 여과장치 등의 정상작동 상태확인 및 이상음 발생 여부 확인",
        isChecked: "",
      },
      {
        title: "1. 공기정화장치",
        content: "여과재의 막힘 또는 파손 여부 및 작동상태 확인",
        isChecked: "",
      },
      {
        title: "1. 공기정화장치",
        content: "접속부의 볼트, 너트, 패킹 등의 이완, 파손 여부 확인 및 공기의 유입 및 누출 여부 확인",
        isChecked: "",
      },
    ],
  },
  {
    title: "배풍기",
    tableHeaderTitle: "확인사항",
    list: [
      {
        title: "1. 배풍기",
        content: "배풍기, 모터의 파손, 부식, 손상 유무 확인",
        isChecked: "",
      },
      {
        title: "1. 배풍기",
        content: "케이싱, 임펠러, 모터 등에서의 이상음 및 이상진동 유무 확인",
        isChecked: "",
      },
      {
        title: "1. 배풍기",
        content: "각종 구동장치, 제어반 등의 정상작동 상태 확인",
        isChecked: "",
      },
      {
        title: "1. 배풍기",
        content: "배풍기의 회전방향 확인 및 성능을 저하시키는 설계정압의 증가 또는 감소 여부 확인",
        isChecked: "",
      },
      {
        title: "1. 배풍기",
        content: "전동기 절연저항값 측정\n» 절연저항[㏁]  ≥  사용전압(V) / 1000+출력(KW)",
        isChecked: "",
      },
      {
        title: "2. 벨트 및 안전덮개",
        content: "벨트의 파손, 탈락, 심한 처짐 및 풀리의 손상 유무 확인",
        isChecked: "",
      },
      {
        title: "2. 벨트 및 안전덮개",
        content: "전동기와 배풍기를 연결하는 벨트 등 안전덮개 설치여부 및 이상유무 확인",
        isChecked: "",
      },
      {
        title: "3. 캔버스",
        content: "캔버스의 파손, 부식, 과도한 수축 또는 팽창 등 이상 유무 확인",
        isChecked: "",
      },
      {
        title: "3. 캔버스",
        content: "송풍기 및 덕트와의 연결부위 등에서 공기의 유입 또는 누출 여부 확인",
        isChecked: "",
      },
    ],
  },
  {
    title: "최종배기구",
    tableHeaderTitle: "확인사항",
    list: [
      {
        title: "1. 구조",
        content: "분진 등 배출 배기구는 직접 외기로 향하도록 개방하여 실외에 설치하는 등 배출되는 분진 등이 작업장으로 재유입되지 않는 구조인지 확인\n" +
          "» 공기정화장치가 설치된 이동식 국소배기장치는 제외\n",
        isChecked: "",
      },
      {
        title: "1. 구조",
        content: "배풍기 등으로의 빗물 유입방지 조치 여부 확인",
        isChecked: "",
      },
    ],
  },
];
